function FormatChecker(file) {

  if (!/\.jpg|\.jpeg|\.png$/.test(file.name.toLowerCase())) {
    return true;
  } else {
    return false;
  }
}
export default FormatChecker;
